import {
    DiagnosisBonificationObject,
} from '@libs/types/src/services/object-type/diagnosis/diagnosis-bonification.object';

export function isDiagnosisBonified(
    bonifications: DiagnosisBonificationObject[] | null | undefined,
    expertise: number | string | null | undefined,
    date: Date | string | null | undefined,
): boolean {
    if (!expertise || !date) return false;

    const referenceDate = new Date(date).getTime();
    if (Number.isNaN(referenceDate)) return false;

    return bonifications?.some((bonification) => {
        if (String(bonification.expertise) !== String(expertise)) return false;

        const validFrom = new Date(bonification.validFrom).getTime();
        const validTo = bonification.validTo ? new Date(bonification.validTo).getTime() : null;

        return validFrom <= referenceDate && (validTo === null || referenceDate <= validTo);
    }) ?? false;
}
